import stores from 'bootstrap/store';

export default async function getDrugWarningLabels({ NDC, signal }) {
  const results = await stores.global.drugs.getDrugWarningLabels({ params: { NDC }, signal });
  const relatedConcepts = results?.results?.[0]?.relatedConcepts || [];
  const warningLabelConcept = relatedConcepts.find(concept => concept.conceptType === 'medispan/warninglabels');
  const warningLabels = warningLabelConcept?.concepts?.map(concept => concept.text) || [];
  return warningLabels;
}
